module.exports = __webpack_public_path__ + "static/media/icon-hospital.cbf8c711.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-hospital.svg
// module id = 271
// module chunks = 0